import { render, staticRenderFns } from "./setDesignHistoryModel.vue?vue&type=template&id=59a321fa&scoped=true&"
import script from "./setDesignHistoryModel.vue?vue&type=script&lang=js&"
export * from "./setDesignHistoryModel.vue?vue&type=script&lang=js&"
import style0 from "./setDesignHistoryModel.vue?vue&type=style&index=0&id=59a321fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a321fa",
  null
  
)

export default component.exports